import { useEffect } from 'react';

import {
  useWalletActions,
  useWalletView,
} from '#/features/wallet/wallet-context';
import { getMaybeEthereum } from '#/features/wallet/ethereum';

import WalletBadgeConnected from './WalletBadgeConnected';
import WalletBadgeConnect from './WalletBadgeConnect';
import WalletBadgeOnboarding from './WalletBadgeOnboarding';
import WalletBadgeRecover from './WalletBadgeRecover';

export default function Wallet() {
  const walletView = useWalletView();

  useGlobalEthereumEventHandlers();

  if (walletView.status === 'progress') {
    return <WalletBadgeOnboarding />;
  }

  if (walletView.nextSignInStep === 'wallet_connection') {
    return <WalletBadgeConnect />;
  }

  if (walletView.nextSignInStep === 'onboarding_and_authentication') {
    return <WalletBadgeRecover />;
  }

  return <WalletBadgeConnected />;
}

function useGlobalEthereumEventHandlers() {
  const walletView = useWalletView();
  const walletActions = useWalletActions();
  const ethereum = getMaybeEthereum();

  useEffect(() => {
    if (ethereum == null) return;

    const handleAccountsChanged = (_accounts: unknown) => {
      if (walletView.isSignedIn) {
        walletActions.reset();
        window.location.reload();
      }
    };

    const handleChainChanged = (_chainId: unknown) => {
      // No need to reset state when the user hasn't connected the wallet yet
      if (walletView.isSignedIn) {
        walletActions.reset();
        window.location.reload();
      }
    };

    ethereum.on('accountsChanged', handleAccountsChanged);
    ethereum.on('chainChanged', handleChainChanged);

    return () => {
      ethereum.removeListener('accountsChanged', handleAccountsChanged);
      ethereum.removeListener('chainChanged', handleChainChanged);
    };
  }, [
    ethereum,
    walletActions,
    walletView.ethereumAddress,
    walletView.isSignedIn,
  ]);
}
